import get from 'lodash/get';
import { createSelector } from 'reselect';

const selectRoute = (state) => get(state, 'router');

const makeSelectLocation = () =>
  createSelector(selectRoute, (routeState) => get(routeState, 'location'));

export { makeSelectLocation };
